/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Box, useTheme } from "@mui/material";
import React from "react";

import MaterialSymbol from "../../../../components/MaterialSymbol";
import { ItemContainer, ItemLabel } from "../../../../components/styled";
import TestIds from "../../../../testIds";

interface EditButtonProps {
  onClick?: () => void;
  testId?: string;
  sx?: React.CSSProperties;
}
export const EditButton: React.FC<EditButtonProps> = ({ onClick, sx, testId }) => {
  const theme = useTheme();

  // The additional `Box` layer was to prevent the button from spanning
  // the entire width
  return (
    <Box
      data-testid={testId}
      sx={{ display: "inline-flex", flexWrap: "nowrap", width: "50px" }}
      data-html2canvas-ignore={true}
    >
      <ItemContainer
        sx={{
          alignItems: "center",
          gap: "4px",
          flexDirection: "row",
          cursor: "pointer",
          ...sx,
        }}
        onClick={onClick}
        data-testid={TestIds.feat.product.card.editPriceButton}
      >
        <ItemLabel
          variant="body2"
          sx={{
            color: theme.colors.primary500,
            textUnderlineOffset: "2px",
            textDecoration: "underline",
          }}
        >
          Edit
        </ItemLabel>
        <MaterialSymbol sx={{ fontSize: 16, color: theme.colors.primary700 }}>Edit</MaterialSymbol>
      </ItemContainer>
    </Box>
  );
};
